<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2fm"><a id="maps"></a><a id="page_xi"><span class="txbf">Maps</span></a></h2><a id="page_xi">
</a><p class="map"><a id="page_xi"></a><a href="#/xhtml/maps01">Map of the Potomac River</a></p>
<p class="map"><span href="#/xhtml/ch07a" title="Link target outside of Sample">War Map of the District of Columbia</span></p>
<p class="map"><span href="#/xhtml/ch09a" title="Link target outside of Sample">Battle Map of the Seven Days around Richmond</span></p>
<p class="map"><span href="#/xhtml/ch10a" title="Link target outside of Sample">Battle Map of Sharpsburg</span></p>
<p class="map"><span href="#/xhtml/ch11a" title="Link target outside of Sample">Battle Map of Chancellorsville</span></p>
<p class="map"><span href="#/xhtml/ch11c" title="Link target outside of Sample">Battle Map of Gettysburg</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// maps.vue?1f67a0a8